import { render, staticRenderFns } from "./NotificationTemplateTreatmentCompositionElement.vue?vue&type=template&id=5d47681e&scoped=true"
import script from "./NotificationTemplateTreatmentCompositionElement.vue?vue&type=script&lang=js"
export * from "./NotificationTemplateTreatmentCompositionElement.vue?vue&type=script&lang=js"
import style0 from "./NotificationTemplateTreatmentCompositionElement.vue?vue&type=style&index=0&id=5d47681e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d47681e",
  null
  
)

export default component.exports